'use client'

import React from 'react'
import { useTimer } from 'react-timer-hook'

interface CountdownTimerProps {
  expiryTimestamp: Date
  onExpire?: () => void
  showDays?: boolean
  className?: string
  format?: 'full' | 'hours' | 'minutes'
}

export function CountdownTimer({
  expiryTimestamp,
  onExpire,
  showDays = false,
  className = '',
  format = 'full',
}: CountdownTimerProps) {
  const { days, hours, minutes, seconds, isRunning } = useTimer({
    expiryTimestamp,
    onExpire,
    autoStart: true,
  })

  if (!isRunning) {
    return null
  }

  const formatNumber = (num: number) => num.toString().padStart(2, '0')

  const formatTime = () => {
    const totalHours = days * 24 + hours

    switch (format) {
      case 'full':
        if (showDays && days > 0) {
          return `${days} ngày ${formatNumber(hours)} : ${formatNumber(minutes)} : ${formatNumber(seconds)}`
        }
        return `${formatNumber(totalHours)} : ${formatNumber(minutes)} : ${formatNumber(seconds)}`
      case 'hours':
        return `${formatNumber(totalHours)} : ${formatNumber(minutes)}`
      case 'minutes':
        const totalMinutes = totalHours * 60 + minutes
        return `${formatNumber(totalMinutes)} : ${formatNumber(seconds)}`
      default:
        return `${formatNumber(totalHours)} : ${formatNumber(minutes)} : ${formatNumber(seconds)}`
    }
  }

  return React.createElement('span', { className }, formatTime())
}
